// Armazena as gravações da voz da criança NO APARELHO (IndexedDB).
// Nada é enviado para servidores. Chave por: `${table}:${line}` (line = 1..10).

const DB_NAME = 'tabuada_voice';
const STORE = 'clips';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const result = fn(store);
    t.oncomplete = () => resolve(result && result.__req ? result.__req.result : undefined);
    t.onerror = () => reject(t.error);
  });
}

export async function saveClip(table, line, blob) {
  await tx('readwrite', (store) => store.put(blob, `${table}:${line}`));
}

export async function getClip(table, line) {
  return new Promise(async (resolve) => {
    try {
      const db = await openDB();
      const t = db.transaction(STORE, 'readonly');
      const req = t.objectStore(STORE).get(`${table}:${line}`);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
}

export async function getClipURL(table, line) {
  const blob = await getClip(table, line);
  return blob ? URL.createObjectURL(blob) : null;
}

// Quantas linhas (1..10) já foram gravadas para uma tabuada.
export async function countTable(table) {
  let n = 0;
  for (let line = 1; line <= 10; line++) {
    // eslint-disable-next-line no-await-in-loop
    if (await getClip(table, line)) n += 1;
  }
  return n;
}

export async function deleteTable(table) {
  for (let line = 1; line <= 10; line++) {
    // eslint-disable-next-line no-await-in-loop
    await tx('readwrite', (store) => store.delete(`${table}:${line}`));
  }
}

export function recordingSupported() {
  return (
    typeof navigator !== 'undefined' &&
    navigator.mediaDevices &&
    typeof navigator.mediaDevices.getUserMedia === 'function' &&
    typeof window !== 'undefined' &&
    'MediaRecorder' in window
  );
}
